import Container from './DisplayOptionsBatchEdit.container';
import DisplayOptionsBatchEdit from './DisplayOptionsBatchEdit';

export default Container(DisplayOptionsBatchEdit);
